import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface Props {
  weddingId: string;
  onSuccess?: () => void;
  onProfileIncomplete?: () => void;
}

const RequestForm: React.FC<Props> = ({ weddingId, onSuccess, onProfileIncomplete }) => {
  const { user } = useAuth();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const { createRequest } = await import("../api/requests");
      await createRequest({ wedding_id: weddingId, message: message || undefined });
      setSubmitted(true);
      onSuccess?.();
    } catch (err) {
      const code = (err as Error & { code?: string })?.code;
      if (code === "PROFILE_INCOMPLETE") {
        onProfileIncomplete?.();
        return;
      }
      setError(err instanceof Error ? err.message : "Request failed");
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return (
      <div className="form">
        <h3>Request an Invitation</h3>
        <p className="form-hint">
          You need an account to request an invitation to this wedding.
        </p>
        <Link to="/login" className="btn btn-primary">
          Sign In to Request
        </Link>
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="success-message">
        <h3>Request Submitted</h3>
        <p>The hosts will review your request and notify you by email.</p>
      </div>
    );
  }

  return (
    <form className="form" onSubmit={handleSubmit}>
      <h3>Request an Invitation</h3>
      <p className="form-hint">
        Signed in as {user.email}. Complete your{" "}
        <Link to="/profile">profile</Link> before requesting — hosts see your
        vibes, dress comfort, and Instagram.
      </p>

      {error && <div className="error-message inline">{error}</div>}

      <div className="form-group">
        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          name="message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={3}
          placeholder="Optional note to the hosts..."
        />
      </div>

      <button type="submit" className="btn btn-primary" disabled={loading}>
        {loading ? "Submitting..." : "Submit Request"}
      </button>
    </form>
  );
};

export default RequestForm;
